import jquery from 'jquery';
import * as tippy from 'tippy.js';
export default class Widget {
    constructor(init = jquery("<div>")) {
        this.init(init);
    }
    init(init = jquery("<div>")) {
        if (init instanceof Widget)
            this.container = init.container;
        else if (!init)
            this.container = jquery("<div>");
        else
            this.container = init;
        this._raw = this.container.get()[0];
        return this;
    }
    raw() {
        return this._raw;
    }
    empty() {
        this.container.empty();
        return this;
    }
    appendTo(widget) {
        if (widget instanceof Widget)
            widget = widget.container;
        widget.append(this.container);
        return this;
    }
    prependTo(widget) {
        if (widget instanceof Widget)
            widget = widget.container;
        widget.prepend(this.container);
        return this;
    }
    append(...widget) {
        widget.forEach(w => {
            if (!w)
                return;
            if (w instanceof Widget)
                w = w.container;
            this.container.append(w);
        });
        return this;
    }
    prepend(widget) {
        if (widget instanceof Widget)
            widget = widget.container;
        this.container.prepend(widget);
        return this;
    }
    css(key, value) {
        this._raw.style[key] = value;
        return this;
    }
    css2(properties) {
        Object.assign(this._raw.style, properties);
        return this;
    }
    tooltip(title) {
        this._raw.setAttribute("title", title);
        return this;
    }
    remove() {
        this._raw.remove();
        return this;
    }
    detach() {
        this.container.detach();
        return this;
    }
    addClass(cls) {
        if (cls)
            this._raw.classList.add(cls);
        return this;
    }
    static wrap(jq) {
        if (typeof jq == "string")
            jq = jquery(jq);
        if (jq instanceof HTMLElement)
            jq = jquery(jq);
        return new Widget(jq);
    }
    text(text) {
        this.raw().textContent = text?.toString() ?? "";
        return this;
    }
    setVisible(visible) {
        if (visible)
            this.container.show();
        else
            this.container.hide();
        return this;
    }
    show() {
        return this.setVisible(true);
    }
    hide() {
        return this.setVisible(false);
    }
    toggleClass(cls, value = null) {
        this._raw.classList.toggle(cls, value);
        return this;
    }
    tapRaw(f) {
        f(this.container);
        return this;
    }
    addTippy(tooltip, options = {}) {
        tippy.default(this.raw(), {
            content: () => {
                if (typeof tooltip == "function") {
                    return c("<div class='ctr-entity-tooltip'></div>").append(tooltip()).raw();
                }
                else {
                    return c("<div class='ctr-entity-tooltip'></div>").append(tooltip).raw();
                }
            },
            arrow: true,
            animation: false,
            delay: 0,
            zIndex: 1000001,
            ...options,
        });
        return this;
    }
    html() {
        return this.raw().outerHTML;
    }
    setInnerHtml(html) {
        this.raw().innerHTML = html;
        return this;
    }
    on(events, handler) {
        this.container.on(events, handler);
        return this;
    }
    setAttribute(name, value = "") {
        this._raw.setAttribute(name, value);
        return this;
    }
    setProperty(name, value) {
        if (value)
            this._raw.setAttribute(name, "");
        else
            this._raw.removeAttribute(name);
        return this;
    }
}
globalThis.c = (s = "<div>") => Widget.wrap(s);
